import React from 'react'
import { OrderDashboardComponent} from "../components";

export const OrderDashboardPage: React.FC = () => <OrderDashboardComponent/>;
